import type React from 'react';
import { useContext } from 'react';
import 'react-phone-input-material-ui/lib/style.css';
import { TextField } from '@ovComponents/2-component/textField/textField';
import { UserContext } from '@providers/userContextProvider';
import { useTheme } from 'hephaestus/web';
import ReactPhoneInput from 'react-phone-input-material-ui';

type PhoneNumberFieldProps = {
  testId?: string;
  label?: string;
  placeholder?: string;
  helpText?: string;
  error?: boolean;
  errorText?: string;
  success?: boolean;
  successText?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  locked?: boolean;
  lockMessage?: string;
  size?: 'small' | 'medium';
  textSize?: string | number;
  textAlign?: 'left' | 'center' | 'right';
  children?: React.ReactNode[] | React.ReactNode;
  value?: any;
  defaultValue?: any;
  onChange?: any;
  onFocus?: any;
  onBlur?: any;
  infoTooltip?: string;
};

export const PhoneNumberField = (props: PhoneNumberFieldProps) => {
  const { value, onChange, onBlur, ...restProps } = props;
  const theme = useTheme();
  const { activeOrganization } = useContext(UserContext);
  const phoneNumberCountryCodes =
    activeOrganization?.applicableLocalization?.phoneNumberCountryCodes?.map(
      (c) => c.toLowerCase(),
    );
  const applicableCountries =
    activeOrganization?.applicableLocalization.countries.map((c) =>
      c.toLowerCase(),
    );
  const countryCodes =
    phoneNumberCountryCodes && phoneNumberCountryCodes.length > 0
      ? phoneNumberCountryCodes
      : applicableCountries;
  const disableDropdown = countryCodes && countryCodes.length === 1;
  return (
    <>
      <style>
        {`
          .phone-input-container input[type=text] {
            padding-left: 50px;
          }
          .phone-input-container.phone-input-no-dropdown input[type=text] {
            padding-left: 14px;
          }
          .phone-input-container .flag-dropdown {
            top: 18px;
            left: 8px;
            height: 45px;
          }
          .phone-input-container .flag {
            transform: scaleX(1.25) scaleY(1.75);
            border-radius: 100%;
          }
          .phone-input-container li {
            padding: 14px 12px !important;
          }
          .phone-input-dropdown {
            font-family: ${theme.font.base};
            font-size: 14px;
          }
        `}
      </style>

      <ReactPhoneInput
        value={value}
        onChange={(phone, countryData) => {
          const digits = phone.replace(/\D/g, '');
          const limited = digits.slice(0, 11);

          onChange({
            value: limited,
            countryCode:
              countryData && 'countryCode' in countryData
                ? countryData.countryCode.toLocaleUpperCase()
                : undefined,
          });
        }}
        onBlur={onBlur}
        onlyCountries={countryCodes}
        dropdownClass='phone-input-dropdown'
        containerClass={
          disableDropdown
            ? 'phone-input-container phone-input-no-dropdown'
            : 'phone-input-container'
        }
        inputProps={restProps}
        component={TextField}
        disableDropdown={disableDropdown}
        enableLongNumbers={false}
      />
    </>
  );
};
